import { render, staticRenderFns } from "./expand.vue?vue&type=template&id=2cc8d03a&scoped=true"
import script from "./expand.vue?vue&type=script&lang=js"
export * from "./expand.vue?vue&type=script&lang=js"
import style0 from "./expand.vue?vue&type=style&index=0&id=2cc8d03a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc8d03a",
  null
  
)

export default component.exports